import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { secureBaseQuery } from "./secureBaseQuery.js";
import { dynamicBaseQuery } from "./dynamicBaseQuery.js";
import { api } from "../../Appjs/api.js";
export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    //  credentials: "include", 
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["User"],

  // tagTypes: ["User"],
  endpoints: (builder) => ({
    signUp: builder.mutation({
      query: (data) => ({
        url: "/auth/signup",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["User"],
    }),
    signIn: builder.mutation({
      query: (data) => ({
        url: "/auth/login",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["User"],
    }),

    verifyOtp: builder.mutation({
      query: (data) => ({
        url: "/auth/verify-otp",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["User"],
    }),
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: "/auth/forgot-password",
        method: "POST",
        body: { username: data.username },
      }),
      invalidatesTags: ["User"],
    }),

    resetPassword: builder.mutation({
      query: ({ password, token }) => ({
        url: "/auth/reset-password",
        method: "POST",
        body: { password },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),

    logOut: builder.mutation({
      query: ({ refreshToken }) => ({
        url: "/auth/logout",
        method: "POST",
        body: { refreshToken },
      }),
      invalidatesTags: ["User"],
    }),
    getProfileDetails: builder.query({
      query: () => ({
        url: "/auth/profile-details",
        method: "GET",
      }),
      providesTags: ["User"],
    }),
    updateProfile: builder.mutation({
      query: (formData) => ({
        url: "/auth/update-profile",
        method: "PUT",
        body: formData, // ab FormData hi bhejna hai
      }),
      invalidatesTags: ["Profile"],
    }),

    changePassword: builder.mutation({
      query: (data) => {
        console.log("Sending data to backend:", data);
        return {
          url: "/auth/change-password",
          method: "PUT",
          body: data,
        };
      },
      invalidatesTags: ["User"],
    }),

    generateOtp: builder.mutation({
      query: (data) => ({
        url: "/auth/generate-otp",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["User"],
    }),
    initialChangePassword: builder.mutation({
      query: (data) => ({
        url: "/auth/initial-change-password",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["User"],
    }),

    checkMpinStatus: builder.query({
      query: () => "/auth/check-mpin-status",
    }),

    verifyMpinStatus: builder.mutation({
      query: (body) => ({
        url: "/auth/verify-mpin-status",
        method: "POST",
        body,
      }),
    }),

    updateMpin: builder.mutation({
      query: (data) => ({
        url: "/auth/update-mpin",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["User"],
    }),

    generateApiKey: builder.query({
      query: () => ({
        url: "/customer/generate-api-key",
        method: "GET",
      }),
    }),
    getCustomerServiceRates: builder.query({
      query: () => ({
        url: "/report/get-customer-service-rates",
        method: "GET",
      }),
    }),
    generateApiKeyNew: builder.mutation({
      query: (Payload) => ({
        url: "/apikey/generate",
        method: "POST",
        body: Payload,
      }),
    }),
    getServiceDropdown: builder.query({
      query: () => ({
        url: "/apikey/functions",
        method: "GET",
      }),
    }),
    getAllApiKeys: builder.query({
      query: () => ({
        url: "/apikey/get-all-apikey",
        method: "GET",
      }),
    }),
    deleteApiKey: builder.mutation({
      query: (id) => ({
        url: `/apikey/delete/${id}`,
        method: "DELETE",
      }),
    }),
    verifyMpin: builder.mutation({
      query: (mdata) => ({
        url: "/apikey/verify-mpin",
        method: "POST",
        body: mdata,
      }),
    }),
    softDeleteApiKey: builder.mutation({
      query: (dltdata) => ({
        url: `/apikey/soft-delete`,
        method: "DELETE",
        body: dltdata,
      }),
    }),
    revokeApiKey: builder.mutation({
      query: (rdata) => ({
        url: `/apikey/revoke-status`,
        method: "PATCH",
        body: rdata,
      }),
    }),
    
  }),
});

export const {
  useSignUpMutation,
  useSignInMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useVerifyOtpMutation,
  useLogOutMutation,
  useGetProfileDetailsQuery,
  useUpdateProfileMutation,
  useChangePasswordMutation,
  useGenerateOtpMutation,
  useInitialChangePasswordMutation,
  useVerifyMpinStatusMutation,
  useCheckMpinStatusQuery,
  useUpdateMpinMutation,
  useGenerateApiKeyNewMutation,
  useLazyGenerateApiKeyQuery,
  useGetCustomerServiceRatesQuery,
  useGetServiceDropdownQuery,
  useGetAllApiKeysQuery,
  useDeleteApiKeyMutation,
  useVerifyMpinMutation,
  useSoftDeleteApiKeyMutation,
  useRevokeApiKeyMutation,
} = userApi;
